import { httpGet, httpPost, httpDelete, httpPut } from "../http";
import { femaCapture } from "../../fema/capture";
import { documentsPageEndpoints } from "../endpoints";
import {
  ApiResponse,
  UploadDocumentResponse,
  ServiceResponse,
  UpdateDocumentRequest,
  SharedDocResponse,
} from "../types";

export class DocumentsPageService {
  static async uploadCustomerDocument(
    customerId: string | number,
    payload: FormData,
    isDocUploadedFromDecl: string,
    entrySource: string = ""
  ): Promise<UploadDocumentResponse> {
    try {
      const response = await httpPost<UploadDocumentResponse>(
        documentsPageEndpoints.uploadCustomerDocument(
          customerId,
          isDocUploadedFromDecl ?? "",
          entrySource ?? ""
        ),
        payload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (error) {
      femaCapture("document_upload_error", error, {
        category: "api",
        severity: "error",
        skipSanitization: false,
        user: {},
      });

      throw error;
    }
  }

  static async getCustomerDocuments(
    customerId: string | number
  ): ServiceResponse<any[]> {
    try {
      const response = await httpGet<ApiResponse<UploadDocumentResponse[]>>(
        documentsPageEndpoints.getCustomerDocuments(customerId)
      );

      return response.data;
    } catch (error) {
      femaCapture("fetching_document_data_error", error, {
        category: "api",
        severity: "error",
        skipSanitization: false,
        user: {},
      });

      throw error;
    }
  }

  static async downloadCustomerDocument(
    fileId: string | number
  ): ServiceResponse<any> {
    try {
      const response = await httpGet<ApiResponse<UploadDocumentResponse[]>>(
        documentsPageEndpoints.downloadCustomerDocument(fileId),
        {
          responseType: "blob",
          headers: {
            Accept: "*/*",
          },
        }
      );

      return response.data;
    } catch (error) {
      femaCapture("download_document_error", error, {
        category: "api",
        severity: "error",
        skipSanitization: false,
        user: {},
      });

      throw error;
    }
  }

  static async deleteCustomerDocument(
    customerId: string | number,
    id: string | number
  ): ServiceResponse<any[]> {
    try {
      const response = await httpDelete<ApiResponse>(
        documentsPageEndpoints.deleteCustomerDocument(customerId, id)
      );

      return response.data;
    } catch (error) {
      femaCapture("delete_document_data_error", error, {
        category: "api",
        severity: "error",
        skipSanitization: false,
        user: {},
      });

      throw error;
    }
  }

  static async updateCustomerDocument(
    payload: UpdateDocumentRequest
  ): Promise<SharedDocResponse> {
    try {
      const response = await httpPut<Document>(
        documentsPageEndpoints.updateCustomerDocument(),
        payload
      );

      return response.data;
    } catch (error) {
      femaCapture("update_document_data_error", error, {
        category: "api",
        severity: "error",
        skipSanitization: false,
        user: {},
      });

      throw error;
    }
  }
}
